exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-box span[data-v-780be565]{margin-right:6px}.departBox[data-v-780be565] .user-item{padding:0}.departBox[data-v-780be565] .select-item{margin-top:0}.departBox[data-v-780be565] .left{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-icon-arrow-down[data-v-780be565]{line-height:34px}\n", ""]);

// exports
